import type { IconProps } from './../../models/icon';

export function GraphIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.12549 11.2113L21.8398 2.24561"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.1543 0.857178L21.84 2.24575L20.4686 5.93146"
        />
        <path
          fill={secondaryColor}
          d="M22.7144 23.1428H18.4287V11.1428C18.4287 10.9155 18.5191 10.6975 18.6797 10.5368C18.8405 10.376 19.0585 10.2857 19.2859 10.2857H21.8573C22.0846 10.2857 22.3027 10.376 22.4635 10.5368C22.6241 10.6975 22.7144 10.9155 22.7144 11.1428V23.1428Z"
        />
        <path
          fill={secondaryColor}
          d="M14.1426 23.1429H9.85693V13.7143C9.85693 13.487 9.94724 13.269 10.108 13.1082C10.2687 12.9475 10.4867 12.8572 10.7141 12.8572H13.2855C13.5128 12.8572 13.7309 12.9475 13.8916 13.1082C14.0523 13.269 14.1426 13.487 14.1426 13.7143V23.1429Z"
        />
        <path
          fill={secondaryColor}
          d="M5.57136 23.1428H1.28564V16.2857C1.28564 16.0584 1.37595 15.8403 1.5367 15.6796C1.69744 15.5189 1.91546 15.4286 2.14279 15.4286H4.71422C4.94155 15.4286 5.15957 15.5189 5.3203 15.6796C5.48105 15.8403 5.57136 16.0584 5.57136 16.2857V23.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.7144 23.1428H18.4287V11.1428C18.4287 10.9155 18.5191 10.6975 18.6797 10.5368C18.8405 10.376 19.0585 10.2857 19.2859 10.2857H21.8573C22.0846 10.2857 22.3027 10.376 22.4635 10.5368C22.6241 10.6975 22.7144 10.9155 22.7144 11.1428V23.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.1426 23.1429H9.85693V13.7143C9.85693 13.487 9.94724 13.269 10.108 13.1082C10.2687 12.9475 10.4867 12.8572 10.7141 12.8572H13.2855C13.5128 12.8572 13.7309 12.9475 13.8916 13.1082C14.0523 13.269 14.1426 13.487 14.1426 13.7143V23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.57136 23.1428H1.28564V16.2857C1.28564 16.0584 1.37595 15.8403 1.5367 15.6796C1.69744 15.5189 1.91546 15.4286 2.14279 15.4286H4.71422C4.94155 15.4286 5.15957 15.5189 5.3203 15.6796C5.48105 15.8403 5.57136 16.0584 5.57136 16.2857V23.1428Z"
        />
      </g>
    </svg>
  );
}
